module.exports = __webpack_public_path__ + "static/media/MOONRIVER.cea46b7c.svg";